import React from "react";
import styled from "styled-components";

const CustomButton = styled.button<{
  $outline?: string;
  $color?: string;
  $disabled?: boolean;
  $backgroundColor?: string;
}>`
  cursor: pointer;
  background-color: ${(props) =>
    props.$disabled
      ? "gray"
      : props.$backgroundColor
      ? props.$backgroundColor
      : "var(--secondary-green)"};
  color: ${(props) => (props.$color ? props.$color : "white")};
  border: ${(props) =>
    props.$outline ? `2px solid  ${props.$outline}` : "none"};
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;

  &:hover {
    transform: ${(props) => (props.$disabled ? "" : "scale(1.05);")};
  }
`;

interface Props {
  id: string;
  text?: string;
  icon?: React.ReactNode;
  onClick: () => void;
  outline?: string;
  disabled?: boolean;
  backgroundColor?: string;
  color?: string;
  isFullWidth?: boolean;
}

const Button: React.FC<Props> = ({
  id,
  text,
  icon,
  onClick,
  outline,
  disabled,
  backgroundColor,
  color,
  isFullWidth,
}) => {
  return (
    <CustomButton
      id={id}
      onClick={!disabled ? onClick : () => {}}
      $outline={outline}
      $disabled={disabled}
      $backgroundColor={backgroundColor}
      $color={color}
      style={{ width: isFullWidth ? "100%" : "auto" }}
    >
      {icon} {text}
    </CustomButton>
  );
};

export default Button;
